package navigation.settings.imagegallery

import navigation.settings.imagegallery.imageInfos.ImageInfosScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val imageGalleryUiModule
    get() =
        module {
            factoryOf(::ImageGalleryScreenModel)
            factoryOf(::ImageInfosScreenModel)
        }